// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-75[data-v-19ad766b]{height:75vh}.h-half-screen[data-v-19ad766b]{height:calc(100vh - 120px)}", ""]);
// Exports
module.exports = exports;
